import { secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';

/**
 * @description Parses an HTML string into a div container. Pass the live
 * `document` to append the container to `document.body`; the returned
 * `cleanup` function removes it. This is needed for `innerText` to respect
 * `display: none` on child elements — note that `innerText` falls back to
 * `textContent` if the container itself has no layout box (e.g. it is
 * `display: none`). Omit the argument (or pass `secureDocument`) to get a
 * detached container with a no-op cleanup. Use this when the same HTML needs
 * to be evaluated more than once — create the container once and pass it to
 * each operator directly.
 */
export const getTextAsDom = (text, parentDocument = secureDocument) => {
  if (!text) {
    return {
      container: null,
      cleanup: () => {}
    };
  }
  const container = parentDocument.createElement('div');
  container.innerHTML = text;
  if (parentDocument === document) {
    parentDocument.body.appendChild(container);
    return {
      container,
      cleanup: () => parentDocument.body.removeChild(container)
    };
  }
  return {
    container,
    cleanup: () => {}
  };
};